import ApiCalls from './util/ApiCalls';

class RoleService {
    async getAll() {
      return ApiCalls.defaultGet("/roles/get-all", {});
    }
}
  
export default new RoleService();